import Text from '@atoms/Text/Text';
import { ICheckbox } from '@models/ICheckbox';
import classNames from 'classnames';
import { useFormContext } from 'react-hook-form';

const Checkbox = ({
  checked,
  dataTestId,
  hideLabelOnMobile,
  indeterminate = false,
  label,
  labelClasses,
  onChange,
  register,
  richTextLabel = false,
  registerOptions,
  showValidationMessage = true,
  ...props
}: ICheckbox) => {
  const methods = useFormContext();
  const error = methods?.formState.errors[props.name];
  const errorMessage = typeof error?.message === 'string' ? error.message : '';
  return (
    <div>
      <label
        className={classNames(
          'tw-item tw-flex tw-cursor-pointer tw-items-start tw-justify-start tw-gap-2 tw-text-[14px] disabled:tw-cursor-default',
          labelClasses
        )}
      >
        <input
          className="tw-peer tw-sr-only tw-order-last tw-appearance-none"
          data-testid={dataTestId}
          type="checkbox"
          checked={checked}
          onChange={onChange}
          {...props}
          {...register?.(`${props.name}`, {
            onChange: (e) => onChange?.(e),
            ...registerOptions,
          })}
        />
        <svg
          viewBox="0 0 18 18"
          aria-hidden="true"
          className="tw-h-xs tw-w-xs tw-shrink-0 tw-translate-y-[3px] tw-rounded tw-border tw-border-grey-80 tw-fill-none tw-stroke-white tw-stroke-2 tw-ring-black tw-transition-all tw-duration-300 tw-ease-in-out peer-checked:tw-bg-grey-80 peer-focus-visible:tw-ring-2 peer-focus-visible:tw-ring-offset-2 peer-disabled:tw-border-grey-40 peer-disabled:peer-checked:tw-bg-grey-40"
        >
          <polyline points={indeterminate ? '3 9 15 9' : '3 8 7 13 15 4'} />
        </svg>
        {richTextLabel ? (
          <Text
            as="div"
            className="tw-rich-text tw-text-black peer-disabled:tw-text-grey-40"
            variant="body-small"
            dangerouslySetInnerHTML={{ __html: label }}
          />
        ) : (
          <p
            className={classNames(
              { 'tw-sr-only md:tw-not-sr-only': hideLabelOnMobile },
              'tw-text-black peer-disabled:tw-text-grey-40'
            )}
          >
            {label}
          </p>
        )}
      </label>
      {!!showValidationMessage && errorMessage && (
        <Text variant="label-12" className="tw-text-red" role="alert">
          {errorMessage}
        </Text>
      )}
    </div>
  );
};

export default Checkbox;
